import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { HashLink } from 'react-router-hash-link'; 
import { HiOutlineMenuAlt4 } from "react-icons/hi";
import { MdOutlineClose } from "react-icons/md"; 
import { FaSignInAlt, FaSignOutAlt, FaUserAlt, FaUserPlus } from "react-icons/fa";
import "../../styles/Nav.css";
import LoginPopup from "../LogIn/LoginPopup";
import { supabase } from "../../supabaseClient"; 

function Nav() {
  const [sideBar, setSideBar] = useState(false);
  const [navBar, setNavBar] = useState(false);
  const [showLogin, setShowLogin] = useState(false);
  const [user, setUser] = useState(null);
  const [checkingSession, setCheckingSession] = useState(true);
  const [profileMenuOpen, setProfileMenuOpen] = useState(false);
  const [forceSignupMode, setForceSignupMode] = useState(false);

  // FOR LOGOUT TRANSITION
  const [isTransitioning, setIsTransitioning] = useState(false);

  const scrollWithOffset = (el) => {
    const yCoordinate = el.getBoundingClientRect().top + window.pageYOffset;
    const yOffset = -80; 
    window.scrollTo({ top: yCoordinate + yOffset, behavior: 'smooth' }); 
  };

  const toggleSidebar = () => setSideBar(!sideBar);

  // FOR LOGOUT
 const handleLogout = async () => {
  setIsTransitioning(true);
  
  await new Promise(resolve => setTimeout(resolve, 800)); 
  await supabase.auth.signOut();
  
  setUser(null);
  setShowLogin(true);
  setIsTransitioning(false);
};

 useEffect(() => {
    const initializeAuth = async () => {
      const { data: { session } } = await supabase.auth.getSession();
      const currentUser = session?.user ?? null;
      
      // 2. Set the user state first
      setUser(currentUser);
      
      // 3. ONLY if the session is definitely null, show the login
      // Do not auto-open login for guests.
      // Users can open login manually from the navbar.

      // if (!currentUser) {
      //   setShowLogin(true);
      // }
      
      // 4. Finally, mark the check as finished
      setCheckingSession(false);
    };

    initializeAuth();

    // Inside your useEffect in Nav.js:
    // const { data: { subscription } } = supabase.auth.onAuthStateChange(
    //   (event, session) => {
    //     const currentUser = session?.user ?? null;

    //     setUser(currentUser);
    //     setCheckingSession(false);

    //     if (currentUser) {
    //       setShowLogin(false);
    //     }
    //   }
    // );

    const { data: { subscription } } = supabase.auth.onAuthStateChange((event, session) => {
      const currentUser = session?.user ?? null;

      setUser(currentUser);
      setCheckingSession(false);

      // Do not auto-close login popup here.
      // LoginPopup will close itself only after successful login.
    });

    const handleScroll = () => {
      setNavBar(window.scrollY >= 120);
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
      subscription.unsubscribe(); 
    };
  }, []);

 const firstName =
  user?.user_metadata?.full_name?.split(" ")[0] ||
  user?.user_metadata?.name?.split(" ")[0] ||
  user?.email?.split("@")[0] ||
  "Guest";


    
  return (
    
    <>
    {isTransitioning && (
      <div className="logout-overlay">
        <img src="/vscimages/preloader/vsc-logo.png" className="pulse-logo" alt="loading" />
        <p>Logging you out...</p>
      </div>  
    )}

    
      <header className={navBar ? "nav-wrap active" : "nav-wrap"}>
        <div className="nav-flex">
          <HashLink smooth to="/#home-hero" scroll={el => scrollWithOffset(el)} className="nav-logo">
            <img src="/vscimages/logo/VICTORIA SPORTS logo(1).png" alt="Logo" />
          </HashLink>

          <nav className="nav-links-container">
            <ul className="nav-links-list">
              <li><HashLink smooth to="/#home-hero" className="text-link" scroll={el => scrollWithOffset(el)} >Home</HashLink></li>
              <li>
                <HashLink smooth to="/#facilities-carousel" scroll={el => scrollWithOffset(el)} className="text-link">
                  Facilities
                </HashLink>
              </li>
              <li><HashLink smooth to="/#home-news" scroll={el => scrollWithOffset(el)} className="text-link">Press</HashLink></li>
              <li><HashLink smooth to="/#home-membership" scroll={el => scrollWithOffset(el)} className="text-link">Membership</HashLink></li>

              {/* Only show content here if user is logged in */}

              {/* BEFORE */}
              {/* {user && (
                <li className="user-nav-group">
                  <span className="user-welcome">Hi, {firstName}</span>
                  <button onClick={handleLogout} className="nav-logout-btn" title="Logout">
                    <MdLogout />
                  </button>
                </li>
              )} */}

              {/* NEW */}
              <li className="profile-menu-wrapper">
                <button
                  type="button"
                  className={user ? "profile-pill logged-in" : "profile-pill"}
                  onClick={() => setProfileMenuOpen(!profileMenuOpen)}
                >
                  <span className={user ? "profile-avatar" : "profile-avatar guest-avatar"}>
                    {user ? firstName?.charAt(0).toUpperCase() : "👤"}
                  </span>

                  <span>{user ? `Hi, ${firstName}` : "Account"}</span>

                  <span className={`profile-arrow ${profileMenuOpen ? "open" : ""}`}>
                    ▾
                  </span>
                </button>

                {profileMenuOpen && (
                  <div className="profile-dropdown">
                    {user ? (
                      <>
                        <Link
                          to="/profile"
                          className="profile-dropdown-item"
                          onClick={() => setProfileMenuOpen(false)}
                        >
                          <FaUserAlt />
                          My Profile
                        </Link>

                        <button
                          type="button"
                          className="profile-dropdown-item danger"
                          onClick={() => {
                            setProfileMenuOpen(false);
                            handleLogout();
                          }}
                        >
                          <FaSignOutAlt />
                          Logout
                        </button>
                      </>
                    ) : (
                      <>
                        <button
                          type="button"
                          className="profile-dropdown-item"
                          onClick={() => {
                            setProfileMenuOpen(false);
                            setForceSignupMode(false);
                            setShowLogin(true);
                          }}
                        >
                          <FaSignInAlt />
                          Login
                        </button>

                        <button
                            type="button"
                            className="profile-dropdown-item"
                            onClick={() => {
                              setProfileMenuOpen(false);
                              setForceSignupMode(true);
                              setShowLogin(true);
                            }}
                          >
                          <FaUserPlus />
                          Create Account
                        </button>
                      </>
                    )}
                  </div>
                )}
              </li>
            </ul>
          </nav>

          <button className="menu-btn" onClick={toggleSidebar}><HiOutlineMenuAlt4 /></button>
        </div>
      </header>

      {/* SIDEBAR */}
      <aside className={sideBar ? "nav-menu active" : "nav-menu"}>
        <div className="sidebar-header">
          <h2>Victoria Sports Club</h2>
          <button onClick={toggleSidebar}><MdOutlineClose /></button>
        </div>
        <ul className="sidebar-links">
          <li><Link to="/" onClick={toggleSidebar}>Home</Link></li>
          <li>
            <HashLink smooth to="/#facilities-carousel" onClick={toggleSidebar} scroll={el => scrollWithOffset(el)}>
              Facilities
            </HashLink>
          </li>
          <li><HashLink smooth to="/#home-news" onClick={toggleSidebar} scroll={el => scrollWithOffset(el)}>Press</HashLink></li>
          <li>
            <HashLink
              smooth
              to="/#home-membership"
              onClick={toggleSidebar}
              scroll={el => scrollWithOffset(el)}
            >
              Membership
            </HashLink>
          </li>

          {user ? (
              <>
                <li className="sidebar-user-info">Logged in: <b>{firstName}</b></li>
                <li>
                  <Link to="/profile" onClick={toggleSidebar}>
                    My Profile
                  </Link>
                </li>
                <li>
                  <button onClick={handleLogout} className="sidebar-auth-btn logout">
                    Logout
                  </button>
                </li>
              </>
            ) : (
              <li>
                <div className="mobile-account-section">
                  <div className="mobile-account-header">
                    <div className="mobile-account-avatar">
                      👤
                    </div>

                    <div>
                      <p className="mobile-account-title">Account</p>
                      <span className="mobile-account-subtitle">
                        Login or create account
                      </span>
                    </div>
                  </div>

                  <button
                    type="button"
                    className="sidebar-auth-btn"
                    onClick={() => {
                      setForceSignupMode(false);
                      setShowLogin(true);
                      setSideBar(false);
                    }}
                  >
                    Login
                  </button>

                  <button
                    type="button"
                    className="sidebar-auth-btn secondary"
                    onClick={() => {
                      setForceSignupMode(true);
                      setShowLogin(true);
                      setSideBar(false);
                    }}
                  >
                    Create Account
                  </button>

                </div>
              </li>
            )}
        </ul>
      </aside>

      {!checkingSession && showLogin && (
        // <LoginPopup onClose={() => setShowLogin(false)} />
        <LoginPopup
          onClose={() => {
            setShowLogin(false);
            setForceSignupMode(false);
          }}
          initialSignup={forceSignupMode}
        />
      )}
    </>
  );
}

export default Nav;



// import React, { useState, useEffect } from "react";
// import { Link } from "react-router-dom";
// // 1. Import the HashLink
// import { HashLink } from 'react-router-hash-link';
// import { HiOutlineMenuAlt4 } from "react-icons/hi";
// import { MdOutlineClose } from "react-icons/md";
// import "../../styles/Nav.css";



// function Nav() {
//   const [sideBar, setSideBar] = useState(false);
//   const [navBar, setNavBar] = useState(false);

//   const toggleSidebar = () => setSideBar(!sideBar);

//   // Helper to handle smooth scroll offset

//   const scrollWithOffset = (el) => {
//     const yCoordinate = el.getBoundingClientRect().top + window.pageYOffset;
//     const yOffset = -80; // This matches your HeroVid offset
//     window.scrollTo({ top: yCoordinate + yOffset, behavior: 'smooth' });

//   };



//   useEffect(() => {
//     const handleScroll = () => {
//       setNavBar(window.scrollY >= 120);
//     };
//     window.addEventListener("scroll", handleScroll);
//     return () => window.removeEventListener("scroll", handleScroll)
//   }, []);



//   return (
//     <>
//       <header className={navBar ? "nav-wrap active" : "nav-wrap"}>
//         <div className="nav-flex">
//           <Link to="/" className="nav-logo">
//             <img src="/vscimages/logo/VICTORIA SPORTS logo(1).png" alt="Logo" />
//           </Link>

//           <nav className="nav-links-container">
//             <ul className="nav-links-list">
//               <li><Link to="/" className="text-link">Home</Link></li>

//               {/* 2. Use HashLink instead of <a> */}

//               <li>
//                 <HashLink
//                   smooth
//                   to="/#facilities-carousel"

//                   scroll={el => scrollWithOffset(el)}

//                   className="text-link"

//                 >

//                   Facilities

//                 </HashLink>

//               </li>



//               <li><HashLink smooth to="/#home-news" scroll={el => scrollWithOffset(el)} className="text-link">Press</HashLink></li>

//               {/* <li><Link to="/events" className="text-link">Events</Link></li> */}



//              <li>

//               <HashLink

//                 smooth

//                 to="/#home-membership"

//                 scroll={el => scrollWithOffset(el)}

//                 className="nav-cta"

//               >

//                 Membership

//               </HashLink>

//             </li>



//             </ul>

//           </nav>



//           <button className="menu-btn" onClick={toggleSidebar}><HiOutlineMenuAlt4 /></button>

//         </div>

//       </header>



//       {/* SIDEBAR UPDATE */}

//       <aside className={sideBar ? "nav-menu active" : "nav-menu"}>

//         <div className="sidebar-header">

//           <h2>Victoria Sports Club</h2>

//           <button onClick={toggleSidebar}><MdOutlineClose /></button>

//         </div>

//         <ul className="sidebar-links">

//           <li><Link to="/" onClick={toggleSidebar}>Home</Link></li>

         

//           {/* 3. Also update the Sidebar link */}

//           <li>

//             <HashLink

//               smooth

//               to="/#facilities-carousel"

//               onClick={toggleSidebar}

//               scroll={el => scrollWithOffset(el)}

//             >

//               Facilities

//             </HashLink>

//           </li>



//           <li><HashLink smooth to="/#home-news" onClick={toggleSidebar} scroll={el => scrollWithOffset(el)} >Press</HashLink></li>

//           {/* <li><Link to="/events" onClick={toggleSidebar}>Events</Link></li> */}

//           <li>

//             <HashLink

//               smooth

//               to="/#home-membership"

//               onClick={toggleSidebar}

//               scroll={el => scrollWithOffset(el)}

//               className="nav-cta"

//             >

//               Membership

//             </HashLink>

//           </li>



          

//         </ul>

//       </aside>

//     </>

//   );

// }



// export default Nav;
